import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import {
  PluginTypeCard,
  PluginTypeCardContent,
  PluginTypeCardFooter,
  FullWidthStack
} from './styles';
import { PLUGIN_TYPES } from '../../../constants/plugin-types';
import {
  getPluginCarouselEnabled,
  getPluginGalleryEnabled,
  getPluginListEnabled,
  getPluginPlaylistEnabled
} from '../../../redux/modules/auth';
import LockableContent from '../../../components/LockableContent/LockableContent';
import { PluginListIcon } from '../../svgs/PluginListIcon';
import { PluginCarouselIcon } from '../../svgs/PluginCarouselIcon';
import { PluginGalleryIcon } from '../../svgs/PluginGalleryIcon';

const pluginTypeContent = [
  {
    type: PLUGIN_TYPES.CAROUSEL,
    name: 'Carousel',
    Display: PluginCarouselIcon
  },
  {
    type: PLUGIN_TYPES.LIST,
    name: 'List',
    Display: PluginListIcon
  },
  {
    type: PLUGIN_TYPES.GALLERY,
    name: 'Gallery',
    Display: PluginGalleryIcon
  }
];

const VpHookPluginTypeDisplay = ({ allowedTypes }) => {
  const { register, setValue, watch } = useFormContext();
  const pluginChoiceValue = watch('pluginChoice', PLUGIN_TYPES.CAROUSEL);

  useEffect(() => {
    register('pluginChoice', {
      required: {
        value: true,
        message: 'Please choose a plugin type'
      },
      value: PLUGIN_TYPES.CAROUSEL
    });
  }, [register]);

  return (
    <FullWidthStack direction="row" justifyContent="center" spacing={4}>
      {pluginTypeContent.map(({ type, name, Display }) => (
        <LockableContent
          isContentLocked={!allowedTypes[type]}
          key={`${type}-plugin-type-card`}
          popoverPlacement="top"
          hideLock
        >
          <PluginTypeCard
            active={type === pluginChoiceValue}
            disabled={!allowedTypes[type]}
            onClick={() => {
              if (allowedTypes[type]) {
                setValue('pluginChoice', type, {
                  shouldDirty: true,
                  shouldValidate: true
                });
              }
            }}
          >
            <PluginTypeCardContent>{<Display />}</PluginTypeCardContent>
            <PluginTypeCardFooter>{name}</PluginTypeCardFooter>
          </PluginTypeCard>
        </LockableContent>
      ))}
    </FullWidthStack>
  );
};

VpHookPluginTypeDisplay.propTypes = {
  allowedTypes: {
    [PLUGIN_TYPES.CAROUSEL]: PropTypes.bool,
    [PLUGIN_TYPES.GALLERY]: PropTypes.bool,
    [PLUGIN_TYPES.LIST]: PropTypes.bool,
    [PLUGIN_TYPES.PLAYLIST]: PropTypes.bool
  }
};

function mapStateToProps(state) {
  return {
    allowedTypes: {
      [PLUGIN_TYPES.CAROUSEL]: getPluginCarouselEnabled(state),
      [PLUGIN_TYPES.GALLERY]: getPluginGalleryEnabled(state),
      [PLUGIN_TYPES.LIST]: getPluginListEnabled(state),
      [PLUGIN_TYPES.PLAYLIST]: getPluginPlaylistEnabled(state)
    }
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VpHookPluginTypeDisplay);



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpCreatePluginDialog/VpHookPluginTypeDisplay.jsx